'use client';
import React, { useState } from 'react';
import { businessData } from '@/config/businessData';

const ContactInfo = () => {
  const [isInteractive, setIsInteractive] = useState(false);
  const [isLoadingMap, setIsLoadingMap] = useState(true);
  const [activeMap, setActiveMap] = useState('india');

  const handleOpenMap = () => {
    setIsInteractive(true);
    setIsLoadingMap(true);
  };

  return (
    <div className="w-full max-w-[1216px] mx-auto px-6 lg:px-2">
      <div className="flex flex-col gap-8">
        <div className="flex flex-wrap gap-6">
          {/* Phone Contact Info */}
          <div className="flex-1 min-w-[280px] bg-white p-6 md:p-8 rounded-xl shadow-[0px_1px_3px_0px_rgba(16,24,40,0.1),0px_1px_2px_0px_rgba(16,24,40,0.06)] border border-[#EAECF0]">
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EFF8FF]">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.31 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z" stroke="#2970FF" strokeWidth="1.5" strokeMiterlimit="10" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-[#101828]">Phone</h3>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-base text-[#475467]">Monday – Saturday: 9:30 AM to 6:30 PM IST</p>
                <a href={`tel:${businessData.contact.phoneLink}`} className="text-lg text-[#2970FF] font-medium hover:underline">{businessData.contact.phoneDisplay}</a>
              </div>
            </div>
          </div>

          {/* Email Contact Info */}
          <div className="flex-1 min-w-[280px] bg-white p-6 md:p-8 rounded-xl shadow-[0px_1px_3px_0px_rgba(16,24,40,0.1),0px_1px_2px_0px_rgba(16,24,40,0.06)] border border-[#EAECF0]">
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EFF8FF]">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.472 14.382C17.119 14.205 15.396 13.36 15.078 13.251C14.76 13.141 14.53 13.088 14.299 13.439C14.07 13.789 13.417 14.556 13.218 14.782C13.02 15.003 12.82 15.029 12.467 14.854C12.115 14.677 10.976 14.305 9.627 13.109C8.567 12.169 7.852 11.009 7.645 10.655C7.436 10.301 7.621 10.111 7.798 9.936C7.957 9.779 8.151 9.53 8.328 9.324C8.505 9.117 8.563 8.956 8.681 8.719C8.799 8.484 8.74 8.278 8.653 8.102C8.564 7.925 7.854 6.182 7.558 5.474C7.269 4.788 6.979 4.882 6.766 4.872C6.571 4.863 6.347 4.862 6.126 4.862C5.903 4.862 5.545 4.945 5.242 5.275C4.94 5.603 4.084 6.402 4.084 8.032C4.084 9.663 5.27 11.239 5.44 11.465C5.611 11.691 7.766 15.013 11.066 16.438C13.82 17.628 14.386 17.391 14.986 17.335C15.932 17.247 16.946 16.708 17.472 15.234C17.999 13.76 17.999 12.493 17.852 12.247C17.705 12.001 17.472 11.865 17.093 11.676H17.472V14.382ZM12.004 2C6.48 2 2 6.48 2 12C2 13.765 2.458 15.426 3.266 16.883L2.012 21.464L6.697 20.236C8.083 20.99 9.664 21.411 11.352 21.411H12.005C17.528 21.411 22.008 16.93 22.008 11.411C22.008 5.891 17.528 1.411 12.005 1.411L12.004 2Z" fill="#2970FF" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-[#101828]">Chat on WhatsApp</h3>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-base text-[#475467]">Our friendly team is here to help.</p>
                <div className="flex flex-col gap-1">
                  <a href={`https://wa.me/${businessData.contact.phoneLink.replace('+', '')}`} target="_blank" rel="noopener noreferrer" className="text-lg text-[#2970FF] hover:underline">{businessData.contact.phoneDisplay}</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Office Contact Info */}
        <div className="flex-1 w-full bg-white p-6 md:p-8 rounded-xl shadow-[0px_1px_3px_0px_rgba(16,24,40,0.1),0px_1px_2px_0px_rgba(16,24,40,0.06)] border border-[#EAECF0]">
          <div className="flex flex-col gap-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EFF8FF]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 13.43C13.7231 13.43 15.12 12.0331 15.12 10.31C15.12 8.58687 13.7231 7.19 12 7.19C10.2769 7.19 8.88 8.58687 8.88 10.31C8.88 12.0331 10.2769 13.43 12 13.43Z" stroke="#2970FF" strokeWidth="1.5" />
                  <path d="M3.62 8.49C5.59 -0.170002 18.42 -0.160001 20.38 8.5C21.53 13.58 18.37 17.88 15.6 20.54C13.59 22.48 10.41 22.48 8.39 20.54C5.63 17.88 2.47 13.57 3.62 8.49Z" stroke="#2970FF" strokeWidth="1.5" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-[#101828]">Office Locations</h3>
            </div>

            <div className="grid sm:grid-cols-2 gap-6 pb-2">
              <div className="flex flex-col gap-2">
                <h4 className="text-xs font-bold text-[#475467] uppercase tracking-wider">India Headquarters</h4>
                <a 
                  href={businessData.address.mapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base text-[#101828] font-medium leading-relaxed hover:text-[#2970FF] hover:underline transition-colors"
                >
                  {businessData.address.line1}<br />
                  {businessData.address.line2} {businessData.address.country}
                </a>
              </div>
              <div className="flex flex-col gap-2">
                <h4 className="text-xs font-bold text-[#475467] uppercase tracking-wider">Sydney Branch Office</h4>
                <a 
                  href={businessData.sydneyAddress.mapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base text-[#101828] font-medium leading-relaxed hover:text-[#2970FF] hover:underline transition-colors"
                >
                  {businessData.sydneyAddress.line1}<br />
                  {businessData.sydneyAddress.line2} {businessData.sydneyAddress.country}
                </a>
              </div>
            </div>

            {/* Map Switcher Tabs */}
            <div className="flex border-b border-[#EAECF0] gap-4">
              <button 
                onClick={() => { setActiveMap('india'); setIsInteractive(false); }} 
                className={`pb-2 text-sm font-semibold border-b-2 transition-all ${activeMap === 'india' ? 'border-[#2970FF] text-[#2970FF]' : 'border-transparent text-[#475467] hover:text-[#101828]'}`}
              >
                India HQ Map
              </button>
              <button 
                onClick={() => { setActiveMap('sydney'); setIsInteractive(false); }} 
                className={`pb-2 text-sm font-semibold border-b-2 transition-all ${activeMap === 'sydney' ? 'border-[#2970FF] text-[#2970FF]' : 'border-transparent text-[#475467] hover:text-[#101828]'}`}
              >
                Sydney Map
              </button>
            </div>
            
            <div className="relative w-full h-[240px] rounded-xl overflow-hidden bg-[#050B14] border border-[#EAECF0] group">
              {!isInteractive ? (
                <div className="absolute inset-0 w-full h-full flex flex-col items-center justify-center p-4 bg-[#0B1528] overflow-hidden">
                  <img
                    src="/images/map-fallback.png"
                    alt="Royal Prime Labels Location Map"
                    className="absolute inset-0 w-full h-full object-cover opacity-85 group-hover:scale-105 transition-transform duration-[1500ms] ease-out z-0"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050B14]/90 via-[#050B14]/40 to-transparent group-hover:bg-[#050B14]/50 transition-colors duration-500 z-0"></div>
                  
                  <div className="relative z-10 flex flex-col items-center gap-2 text-center pointer-events-auto">
                    <button
                      type="button"
                      onClick={handleOpenMap}
                      className="px-4 py-2 bg-[#C9A84C] hover:bg-white text-slate-950 text-sm font-bold rounded-full shadow-md hover:scale-105 active:scale-95 transition-all flex items-center gap-1.5 cursor-pointer relative z-20"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
                        <line x1="8" y1="2" x2="8" y2="18"></line>
                        <line x1="16" y1="6" x2="16" y2="22"></line>
                      </svg>
                      Open Live Google Map
                    </button>
                    
                    <a
                      href={activeMap === 'india' ? businessData.address.mapsLink : businessData.sydneyAddress.mapsLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-3.5 py-1.5 bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm font-semibold rounded-full border border-white/20 text-xs hover:scale-105 transition-all flex items-center gap-1.5 relative z-20"
                    >
                      Get Directions
                    </a>
                  </div>
                </div>
              ) : (
                <div className="w-full h-full relative bg-[#050B14]">
                  {isLoadingMap && (
                    <div className="absolute inset-0 w-full h-full flex flex-col items-center justify-center bg-[#0B1528] text-white z-20">
                      {/* Premium Spinner */}
                      <div className="w-8 h-8 border-4 border-[#C9A84C] border-t-transparent rounded-full animate-spin mb-2"></div>
                      <span className="text-xs font-semibold tracking-wide text-slate-300">Loading Live Google Map...</span>
                    </div>
                  )}
                  
                  <iframe
                    src={activeMap === 'india' 
                      ? "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3489.9678191246733!2d77.0844206!3d28.9292316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390daef33894555f%3A0x72414be7599124c1!2sROYAL%20PRIME%20LABELS!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                      : businessData.sydneyAddress.embedUrl
                    }
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen={true}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    onLoad={() => setIsLoadingMap(false)}
                    className="w-full h-full relative z-10"
                  ></iframe>
                  
                  <button
                    type="button"
                    onClick={() => setIsInteractive(false)}
                    className="absolute top-3 right-3 bg-slate-900/90 hover:bg-slate-900 text-white backdrop-blur-md px-2.5 py-1 rounded-full text-[10px] font-bold shadow-md flex items-center gap-1 border border-white/10 hover:scale-105 transition-all z-30"
                  >
                    Minimize
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
